/*
 * @Author: your name
 * @Date: 2020-12-24 14:39:33
 * @LastEditTime: 2021-03-19 13:54:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\assets\js\Admin\admin.js
 */
import { isvalidPass, emailTest, mobileTest } from '@/assets/js/common'
import { sendCaptcha, getCaptcha, editEmail, getLogList, addPlatformAdmin, queryUserList, oprateUser ,login} from '@/api/index'
export default {
  props: ['userInfo'],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!isvalidPass(value)) {
        callback(new Error('长度在6~18之间，包含字母、数字'));
      } else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      // else if (value == this.addAdminForm.password) {
      //   callback(new Error('新密码和原密码不能一致哦!'))
      // }
      else if (!isvalidPass(value)) {
        callback(new Error('密码长度在6~18之间 包含字母和数字'))
      }
      else {
        if (this.editPasswordRuleForm.checkPass !== '') {
          this.$refs.editPasswordRuleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.editPasswordRuleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'));
      } else if (!emailTest(value)) {
        callback(new Error('请输入包含@的合法的邮箱!'));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (!mobileTest(value)) {
        callback(new Error('请输入11位有效的手机号码!'));
      } else {
        callback();
      }
    };
    var validateNewEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新邮箱'));
      } else if (value == this.editInfoForm.email) {
        callback(new Error('新邮箱和旧邮箱不能一致!'));
      } else if (!emailTest(value)) {
        callback(new Error('请输入包含@的合法的邮箱!'));
      } else {
        callback();
      }
    };
    // 重置admin密码
    let oldPass = sessionStorage.getItem('password')
    var validatePassAdmin = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else if (value != oldPass) {
        callback(new Error('原密码输入不正确'));
      } else {
        callback();
      }
    };
    var validatePassAdmin1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      }
      else if (value == this.editAdminPwRuleForm.oldPassword) {
        callback(new Error('新密码和原密码不能一致哦!'))
      }
      else if (!isvalidPass(value)) {
        callback(new Error('密码长度在6~18之间 包含字母和数字'))
      }
      else {
        if (this.editAdminPwRuleForm.checkPass !== '') {
          this.$refs.editAdminPwRuleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePassAdmin2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.editAdminPwRuleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      findParams: {
        createTimeStr: '',
        personNo: '',
        email: '',
        sort: 'desc',
        pageNumber: 1,
        pageSize: 10,
        startTimeStr: "",
        endTimeStr: "",
        userType: ''
      },
      activeIndex: 0,
      status: 1,
      flag: '',
      email: sessionStorage.getItem('email'),
      activeName: '1',
      adminTableData: [],
      isRotate: true,
      totalPage: 0,
      addAdminVisible: false,
      addPermissionVisible: false,
      tagsData: [], //权限数据
      permissionData: [
        // {
        //   id: 1,
        //   name: '调查表修改申请',
        //   status: false
        // },
        // {
        //   id: 4,
        //   name: '资质、补贴及荣誉审核',
        //   status: false
        // },
        // {
        //   id: 3,
        //   name: '申请入会',
        //   status: false
        // },
        // {
        //   id: 2,
        //   name: '产品发布',
        //   status: false
        // },
        // {
        //   id: 5,
        //   name: '企业联系人审核',
        //   status: false
        // },
        {
          id: 6,
          name: '缴费记录权限',
          status: false
        },
        {
          id: 7,
          name: '缴费管理',
          status: false
        },
      ],
      addAdminForm: {
        id: '',
        personNo: '',
        userName: '',
        email: '',
        phone: '',
        password: '',
        userPermission: ''
      },
      addAdminFormRules: {
        personNo: [{ required: true, message: '请输入人员编号', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        userPermission: [{ required: true, message: '请添加权限', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        userName: [{ required: true, message: '请输入账号名', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        email: [{ required: true, validator: validateEmail, trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        phone: [{ required: true, validator: validateMobile, trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }
        ],
      },
      passwordVisible: false,
      editPasswordRuleForm: {
        newPassword: '',
        checkPass: ''
      },
      editPasswordRules: {
        newPassword: [
          { required: true, validator: validatePass1, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      editInfoVisible: false,
      stepActive: 0,
      isDisable: false,
      time: 60,
      timer: null,
      editInfoForm: {
        email: '',
        captcha: ''
      },
      editInfoRules: {
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      newEmailForm: {
        newEmail: '',
        email: '',
        captcha: ''
      },
      newEmailRules: {
        newEmail: [{ required: true, validator: validateNewEmail, trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      operationData: [],
      mineData: [], //本账号操作记录
      mineParams: {
        pageNumber: 1,
        pageSize: 10,
        operationType: '',  // 1本2下
        mineTime: [],
        startTimeStr: '',
        endTimeStr: '',
        operationName: '',
        theme: '',
        sort: '',
        userName: ''
      },
      mineTotalPage: 0,
      otherTotalPage: 0,
      otherData: [], //下级账号操作记录
      valueTime: '',
      stausType: [
        {
          value: "",
          label: '全部'
        }, {
          value: 1,
          label: '启用'
        }, {
          value: 2,
          label: '禁用'
        },
      ],
      // 修改admin密码
      editAdminPwVisible:false,
      editAdminPwRuleForm: {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      },
      editAdminPwRules: {
        oldPassword: [
          { required: true, validator: validatePassAdmin, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePassAdmin1, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePassAdmin2, trigger: 'blur' }
        ]
      },
      roleType: sessionStorage.getItem('roleType'),
      centerDialogVisible:false,
      loginRuleForm: {
        email: 'wwj13012021@163.com',
        password: 'abc123'
      },
    }
  },
  created() {
    this.getAdminInfo()
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    // 请选择身份进入
    async roleAdminLogin(){
      try {
        const { data } = await login(this.loginRuleForm)
        if (data.code == 0) {
          sessionStorage.setItem('token', data.token)
          sessionStorage.setItem('email', this.loginRuleForm.email)
          sessionStorage.setItem('password', this.loginRuleForm.password)
          sessionStorage.setItem('userPermissionType', data.userPermissionType)
          this.$store.commit('saveRoleType', data.roleType)
          this.$store.commit('saveUserId', data.userId)
          // data.roleType 1-admin 2-协会工作人员（管理员） 3-会员
          
          this.$router.push('/home/adminManagement')
          this.$forceUpdate()
          setTimeout(function(){
            location.reload();
          },100)
          
        }
      } catch (error) {
        // console.log(error);
        this.$message.error(error.data.msg);
      }
    },
    // 修改admin密码
    closeAdminPwDialog() {
      this.$refs.editAdminPwRuleForm.resetFields();
    },
    holdNewAdminPw(type, id) {
      this.$refs.editAdminPwRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm('密码修改后需要重新登录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async (res) => {
            if (res == 'confirm') {
              let param = {
                id: id,
                password: this.editAdminPwRuleForm.newPassword
              }
              const { data } = await oprateUser(type, param)
              
              if (data.code != 0) return
              this.passwordVisible = false
              this.$router.push('/login')
              sessionStorage.clear()
            }

          }).catch(() => {
            console.log('取消修改');
          });

        }
      })
    },
    handleTabClick(tab) {
      if (tab.name == '1') {
        this.getAdminInfo()
      } else if (tab.name == '2') {
        this.getOprationLog()
      }
    },
    async getOprationLog() {
      if (this.activeIndex == 0) {
        if (this.isRotate) {
          this.mineParams.sort = 'desc'
        } else {
          this.mineParams.sort = 'asc'
        }
        this.mineParams.operationType = 1
        const { data } = await getLogList(this.mineParams)
        
        if (data.code != 0) return
        this.mineData = JSON.parse(JSON.stringify(data.recordDtoList))
        this.mineTotalPage = data.total
      } else if (this.activeIndex == 1) {
        if (this.isRotate) {
          this.mineParams.sort = 'desc'
        } else {
          this.mineParams.sort = 'asc'
        }
        this.mineParams.operationType = 2
        const { data } = await getLogList(this.mineParams)
        
        if (data.code != 0) return
        this.otherData = JSON.parse(JSON.stringify(data.recordDtoList))
        this.otherTotalPage = data.total
      }
    },
    minOpaLog() {
      this.activeIndex = 0
      this.mineParams.mineTime = []
      this.mineParams.startTimeStr = ''
      this.mineParams.endTimeStr = ''
      this.mineParams.operationName = ''
      this.mineParams.theme = ''
      this.mineParams.sort = ''
      this.mineParams.userName = ''
      this.getOprationLog()
    },
    otherOpaLog() {
      this.activeIndex = 1
      this.mineParams.mineTime = []
      this.mineParams.startTimeStr = ''
      this.mineParams.endTimeStr = ''
      this.mineParams.operationName = ''
      this.mineParams.theme = ''
      this.mineParams.sort = ''
      this.mineParams.userName = ''
      this.getOprationLog()
    },
    changeTime(time) {
      this.mineParams.mineTime = time
      this.mineParams.startTimeStr = time[0]
      this.mineParams.endTimeStr = time[1]
      this.getOprationLog()
    },
    mineCurrentChange(page) {
      this.mineParams.pageNumber = page
      this.getOprationLog()
    },
    mineHandleImg() {
      this.isRotate = !this.isRotate
      this.getOprationLog()
    },

    otherCurrentChange(page) {
      this.mineParams.pageNumber = page
      this.getOprationLog()
    },
    logout() {
      this.$confirm('确定进行[退出]操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear()
        this.$router.push('/login')
      }).catch(() => {
        console.log('取消退出');
      });
    },
    handleSwitch(row) {
      if (row.disabled) {
        this.addAdminForm.id = row.id
        this.updateOrDelUser(3)
      } else {
        this.addAdminForm.id = row.id
        this.updateOrDelUser(2)
      }
    },
    async getAdminInfo() {
      const { data } = await queryUserList(this.findParams)
      if (data.code !== 0) return
      this.totalPage = data.total
      this.adminTableData = JSON.parse(JSON.stringify(data.userList))
    },
    timeChange(val) {
      if (val == null) {
        this.findParams.startTimeStr = ''
        this.findParams.endTimeStr = ''
      } else {
        this.findParams.startTimeStr = this.$dayjs(val[0]).format("YYYY-MM-DD")
        this.findParams.endTimeStr = this.$dayjs(val[1]).format("YYYY-MM-DD")
      }
      this.getAdminInfo()
    },
    handleImg() {
      this.isRotate = !this.isRotate
      if (this.isRotate) { this.getAdminInfo(this.findParams.sort = 'desc') } else {
        this.getAdminInfo(this.findParams.sort = 'asc')
      }
    },
    addNewMember() {
      this.flag = 1
      this.addAdminVisible = true
      this.addAdminForm = {}

    },
    // 添加权限
    handlePermission() {
      this.addPermissionVisible = true
      if (this.flag == 2) {
        this.permissionData.forEach((item, index) => {
          this.tagsData.forEach((val, i) => {
            if (item.id == val.id) {
              item.status = true
            }
          })
        })
      }
      // this.tagsData = []
      // this.permissionData.forEach((item, index) => {
      //   item.status = false
      // })
    },
    // 清除选好的权限
    handleClose(tag, index) {
      this.tagsData.splice(index, 1);
      this.permissionData.forEach((val, i) => {
        if (tag.name == val.name) {
          val.status = false
        }
      })
    },
    clickButton(item, index) {
      this.permissionData[index].status = !this.permissionData[index].status
    },
    permissionSure() {
      this.tagsData = []
      this.permissionData.forEach((item, index) => {
        if (item.status) {
          this.tagsData.push({ name: this.permissionData[index].name, id: this.permissionData[index].id })
        }
      })

      this.addPermissionVisible = false
    },
    //添加or修改管理员提交
    submitAdmin() {
      this.addAdminForm.userPermission = this.tagsData.map(item => item.id).join(',')
      this.$refs.addAdminForm.validate(async (valid) => {
        if (valid) {
          const { data } = await addPlatformAdmin(this.addAdminForm)
          if (data.code == 0) {
            // this.$refs.addAdminForm.resetFields();
            this.addAdminVisible = false
            this.getAdminInfo()
          } else if (data.code == 500) {
            // this.tagsData = []
            this.$message.error(data.msg)
          }

        }
      })
    },
    cancelButton() {
      this.permissionData[0].status = false
      this.addPermissionVisible = false
    },
    closeDialog() {
      this.$refs.addAdminForm.resetFields();
      this.tagsData = []
    },
    handleCurrentChange(page) {
      this.findParams.pageNumber = page
      this.getAdminInfo()
    },
    // 编辑管理员信息
    editAdmin(data) {
      this.flag = 2
      this.addAdminVisible = true
      this.addAdminForm.personNo = data.personNo
      this.permissionData.forEach((item, index) => {
        data.userPermission.split(",").forEach((val, i) => {
          if (item.id == val) {
            this.tagsData.push({ name: item.name, id: val })
          }
        })
      })
      this.addAdminForm.userName = data.userName
      this.addAdminForm.email = data.email
      this.addAdminForm.phone = data.phone
      this.addAdminForm.id = data.id
    },
    deleteAdmin(row) {
      this.addAdminForm.id = row.id
      this.$confirm('确定删除该管理员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        if (res == 'confirm') {
          this.updateOrDelUser(4)
        }
      }).catch(() => {
        console.log('取消删除');
      });

    },
    resetPassword(row) {
      this.passwordVisible = true
      this.addAdminForm.id = row.id
      this.addAdminForm.password = row.password
    },
    holdNewPassword() {
      this.$refs.editPasswordRuleForm.validate((valid) => {
        if (valid) {
          this.updateOrDelUser(5)
        }
      })
    },
    closeEditDialog() {
      this.$refs.editPasswordRuleForm.resetFields();
    },
    //修改或删除管理员信息
    async updateOrDelUser(type) {
      this.addAdminForm.password = this.editPasswordRuleForm.newPassword
      const { data } = await oprateUser(type, this.addAdminForm)
      if (data.code == 0) {
        if (type === 1) {
          // this.$refs.addAdminForm.resetFields();
          this.addAdminVisible = false
        } else if (type === 4) {
          console.log('删除成功');
        } else if (type === 5) {
          this.passwordVisible = false
        }
        this.getAdminInfo()
      } else if (data.code == 500) {
        this.$message.error(data.msg)
        this.tagsData = []
      }
    },
    submitEditAdmin() {
      this.addAdminForm.userPermission = this.tagsData.map(item => item.id).join(',')
      this.$refs.addAdminForm.validate((valid) => {
        if (valid) {
          this.updateOrDelUser(parseInt(1))
        }
      })
    },
    async sendCode(email) {
      clearInterval(this.timer)
      const { data } = await sendCaptcha(email)
      if (data.code == 0) {
        this.isDisable = true
        this.timer = setInterval(() => {
          if (this.time < 1) {
            clearInterval(this.timer)
            this.isDisable = false
            this.time = 60
          } else {
            this.time -= 1
          }
        }, 1000);
      } else {
        this.$message.error(data.msg)
      }
    },
    next() {
      try {
        if (this.userInfo) {
          this.editInfoForm.email = this.userInfo.email
          this.$refs.editInfoForm.validate(async (valid) => {
            if (valid) {
              try {
                const { data } = await getCaptcha(this.editInfoForm)
                if (data.code == 0) {
                  this.stepActive = 1
                  clearInterval(this.timer)
                  this.isDisable = false
                  this.time = 60
                } else {
                  this.$message.error(data.msg)
                }

              } catch (error) {
                this.$message.error(error.data.msg)
              }
            }
          })
        }
      } catch (error) {
        this.message.error(data.msg)
      }
    },
    nextStep() {
      if (this.userInfo) {
        this.newEmailForm.email = this.userInfo.email
        this.$refs.newEmailForm.validate(async (valid) => {
          if (valid) {
            const { data } = await editEmail(this.newEmailForm)
            if (data.code == 0) {
              this.stepActive = 2
            } else {
              this.$message.error(data.msg)
              this.stepActive = 1
            }
          }
        })
      }
    },
    previousStep() {
      this.stepActive = 0
      clearInterval(this.timer)
      this.isDisable = false
      this.time = 60
    },

    editSuccess() {
      this.editInfoVisible = false
      this.$parent.init()
    },
    closeeditInfoDialog() {
      this.stepActive = 0
      this.$refs.editInfoForm.resetFields();
      this.$refs.newEmailForm.resetFields();
    },
  }
}